(function () {
  var REVISION = '2024-10-15';

  function widgetScope(widget) {
    return widget.closest('.shopify-section--main-product') || widget.closest('.shopify-section') || document;
  }

  function variantsFor(widget) {
    if (widget.__hnVariants) return widget.__hnVariants;
    var el = widget.querySelector('[data-hn-variants]');
    if (!el) return [];
    try { widget.__hnVariants = JSON.parse(el.textContent); } catch (e) { widget.__hnVariants = []; }
    return widget.__hnVariants;
  }

  function selectedVariant(widget) {
    var scope = widgetScope(widget);
    var variants = variantsFor(widget);
    if (!variants.length) return null;

    var opts = [];
    var i = 1;
    var input;
    while ((input = scope.querySelector('input[type="radio"][name="option' + i + '"]:checked:not([disabled])'))) {
      opts.push(input.value);
      i++;
    }

    if (opts.length) {
      for (var v = 0; v < variants.length; v++) {
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (String(variants[v].options[j] || '') !== String(opts[j] || '')) { ok = false; break; }
        }
        if (ok) return variants[v];
      }
    }

    var idInput = scope.querySelector('form[is="product-form"] input[name="id"], form.shopify-product-form input[name="id"]');
    if (idInput && idInput.value) {
      for (var k = 0; k < variants.length; k++) {
        if (String(variants[k].id) === String(idInput.value)) return variants[k];
      }
    }

    return null;
  }

  function syncWidget(widget) {
    /* The visible trigger is the theme's own ATC button (data-haus-notify-proxy state
       in product-swatch-ajax.js); here we only track the selected variant. */
    widget.__hnSelected = selectedVariant(widget);
  }

  function syncAll() {
    document.querySelectorAll('[data-haus-notify]').forEach(syncWidget);
  }

  /* Ancestor transforms inside the product section trap position:fixed and
     let the header paint over the modal. Portal it to <body> on first open. */
  function modalFor(widget) {
    if (widget.__hnModal && document.body.contains(widget.__hnModal)) return widget.__hnModal;
    var modal = widget.querySelector('[data-hn-modal]');
    if (modal) {
      document.querySelectorAll('body > [data-hn-modal]').forEach(function (m) { m.remove(); });
      document.body.appendChild(modal);
      modal.__hnWidget = widget;
      widget.__hnModal = modal;
    }
    return modal;
  }

  function widgetForNode(node) {
    var modal = node.closest('[data-hn-modal]');
    if (modal && modal.__hnWidget) return modal.__hnWidget;
    return node.closest('[data-haus-notify]');
  }

  function openModal(widget) {
    syncWidget(widget);
    var variant = widget.__hnSelected;
    var modal = modalFor(widget);
    if (!modal || !variant) return;

    var label = modal.querySelector('[data-hn-variant-label]');
    if (label) label.textContent = variant.title || '';

    var formStep = modal.querySelector('[data-hn-step="form"]');
    var successStep = modal.querySelector('[data-hn-step="success"]');
    if (formStep) formStep.hidden = false;
    if (successStep) successStep.hidden = true;

    var err = modal.querySelector('[data-hn-error]');
    if (err) err.hidden = true;

    modal.hidden = false;
    document.documentElement.classList.add('hn-modal-open');

    var email = modal.querySelector('[data-hn-email]');
    if (email) setTimeout(function () { email.focus(); }, 50);
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.documentElement.classList.remove('hn-modal-open');
  }

  function submitWidget(widget) {
    if (!widget) return;
    var modal = widget.__hnModal || widget.querySelector('[data-hn-modal]');
    if (!modal) return;

    var variant = widget.__hnSelected;
    var emailInput = modal.querySelector('[data-hn-email]');
    var err = modal.querySelector('[data-hn-error]');
    var btn = modal.querySelector('[data-hn-submit]');
    var email = ((emailInput && emailInput.value) || '').trim();

    if (!variant) return;

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (err) { err.textContent = 'Please enter a valid email address.'; err.hidden = false; }
      return;
    }

    if (err) err.hidden = true;
    if (btn) { btn.disabled = true; btn.__hnLabel = btn.textContent; btn.textContent = 'Submitting...'; }

    var company = widget.getAttribute('data-hn-company');

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant.id } }
          }
        }
      })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.text().then(function (t) { throw new Error(t || String(res.status)); });
        }
        var formStep = modal.querySelector('[data-hn-step="form"]');
        var successStep = modal.querySelector('[data-hn-step="success"]');
        if (formStep) formStep.hidden = true;
        if (successStep) successStep.hidden = false;
      })
      .catch(function () {
        if (err) { err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; }
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.__hnLabel || 'Notify Me When Available'; }
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-hn-trigger]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger.closest('[data-haus-notify]'));
      return;
    }

    var closeEl = e.target.closest('[data-hn-close]');
    if (closeEl) {
      var modal = closeEl.closest('[data-hn-modal]');
      if (modal) closeModal(modal);
      return;
    }

    var submitBtn = e.target.closest('[data-hn-submit]');
    if (submitBtn) {
      e.preventDefault();
      submitWidget(widgetForNode(submitBtn));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('[data-hn-modal]:not([hidden])');
      if (open) closeModal(open);
      return;
    }
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-hn-email]')) {
      e.preventDefault();
      submitWidget(widgetForNode(e.target));
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[type="radio"][name^="option"]')) return;
    setTimeout(syncAll, 0);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if ((node.matches && node.matches('[data-haus-notify]')) || (node.querySelector && node.querySelector('[data-haus-notify]'))) {
          setTimeout(syncAll, 0);
          return;
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
